import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { filterConstants } from "../../../../../redux/constants";
import CustomCheckBox from "../../../../customCheckBox";
import { useTranslation } from "react-i18next";
const { SEPIA } = filterConstants;

const SepiaFilter = ({ applyFilter, fabric }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const _filter = useSelector((state) => state.filter);
  const applySepia = (check) => {
    dispatch({
      type: SEPIA,
      payload: check,
    });
    applyFilter(3, check && new fabric.Image.filters.Sepia());
  };
  return (
    <div>
      <CustomCheckBox
        lable={t("SepiaFilter.Sepia")}
        checked={_filter.sepia}
        onClick={(e) => applySepia(e.target.checked)}
      />
    </div>
  );
};

export default SepiaFilter;
